var exports = {
  "M": "x112a1f60--5db3a5--page",
};

module.exports = exports;
